import { ClipLoader } from "react-spinners";
import { cn } from "@utils";

const Button = ({
  onClick,
  type = "button",
  children,
  disabled,
  submitting,
  color = "secondary",
  customColor,
  className,
  size = "md",
  title,
  "aria-label": ariaLabel,
}) => {
  const textSize = size == "xs" ? "xs" : "sm";

  const padding = {
    xs: "px-2 py-1",
    sm: "px-2 py-1",
    md: "px-2.5 py-1.5",
    lg: "px-3 py-2",
    xl: "px-3.5 py-2.5",
  };

  const styles = {
    primary:
      "text-white bg-primary-500 shadow-sm hover:bg-primary-600 active:bg-primary-700 shadow-sm  disabled:bg-zinc-200 disabled:text-zinc-400 disabled:ring-1 disabled:ring-inset disabled:ring-zinc-300",
    secondary:
      "text-zinc-900 bg-white shadow-sm ring-1 ring-inset ring-zinc-300 hover:bg-zinc-50 active:bg-zinc-200 disabled:text-zinc-400 disabled:ring-zinc-200", // ring-zinc-200
    secondaryLink:
      "text-zinc-500 hover:text-zinc-600 active:text-zinc-700 disabled:text-zinc-300", // ring-zinc-200
    link: "text-primary-500 hover:text-primary-600 active:text-primary-700 disabled:text-zinc-400 ",
    text: "hover:text-zinc-600 active:text-zinc-700 hover:bg-zinc-100 active:bg-zinc-200 disabled:text-zinc-400 hover:ring-1 hover:ring-inset ring-zinc-200",
    dangerlink:
      "text-red-500 hover:text-red-600 active:text-red-700 disabled:text-zinc-400", // "destructive"" in Figma
    danger:
      "text-white bg-red-500 hover:bg-red-600 ring-1 ring-inset ring-red-600 disabled:ring-red-200 disabled:bg-red-200 active:bg-red-700", // "destructive"" in Figma
  };

  const handleClick = () => {
    if (submitting) return;
    if (onClick) onClick();
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled || submitting}
      type={type}
      title={title}
      aria-label={ariaLabel}
      className={cn(
        "flex items-center justify-center rounded-md font-medium focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 transition-all duration-200",
        `text-${textSize}`,
        padding[size],
        !customColor && styles[color],
        submitting && "bg-primary-700",
        className,
      )}
      style={
        customColor?.backgroundColor
          ? {
              backgroundColor: customColor.backgroundColor || "white",
              color: customColor.textColor || "black",
            }
          : {}
      }
    >
      {submitting ? (
        <>
          <ClipLoader size={12} color="white" className="mr-2" /> Loading
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
